/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content */
export default function LanguagePopup() {
  return (
    <>
    <div className="language-popup-overlay" id="languagePopup" aria-hidden="true">
      <div className="language-popup" role="dialog" aria-modal="true" aria-labelledby="languagePopupTitle">
        <button className="language-popup-close" type="button" aria-label="Close language popup">
          {"×"}
        </button>
        <div className="language-popup-head">
          <span className="language-popup-icon">
            <i className="fa-solid fa-globe"></i>
          </span>
          <div>
            <h3 id="languagePopupTitle">
              {"Choose Language"}
            </h3>
            <p>
              {"Select your preferred website language"}
            </p>
          </div>
        </div>
        <div className="language-options">
          <button className="language-option" type="button" data-language-choice="en" data-language-url="index.html">
            <span className="language-flag" aria-hidden="true">
              <svg className="language-flag-svg" viewBox="0 0 60 60" focusable="false">
                <clipPath id="flagGbClip">
                  <circle cx="30" cy="30" r="30"></circle>
                </clipPath>
                <g clipPath="url(#flagGbClip)">
                  <path fill="#012169" d="M0 0h60v60H0z"></path>
                  <path stroke="#fff" strokeWidth="12" d="m0 0 60 60M60 0 0 60"></path>
                  <path stroke="#c8102e" strokeWidth="7" d="m0 0 60 60M60 0 0 60"></path>
                  <path stroke="#fff" strokeWidth="20" d="M30 0v60M0 30h60"></path>
                  <path stroke="#c8102e" strokeWidth="12" d="M30 0v60M0 30h60"></path>
                </g>
              </svg>
            </span>
            <span>
              <strong>
                {"English"}
              </strong>
              <small>
                {"Continue in English"}
              </small>
            </span>
          </button>
          <button className="language-option" type="button" data-language-choice="ar" data-language-url="ar/index.html">
            <span className="language-flag" aria-hidden="true">
              <svg className="language-flag-svg" viewBox="0 0 60 60" focusable="false">
                <clipPath id="flagAeClip">
                  <circle cx="30" cy="30" r="30"></circle>
                </clipPath>
                <g clipPath="url(#flagAeClip)">
                  <path fill="#fff" d="M0 0h60v60H0z"></path>
                  <path fill="#00732f" d="M18 0h42v20H18z"></path>
                  <path fill="#000" d="M18 40h42v20H18z"></path>
                  <path fill="#ff0000" d="M0 0h20v60H0z"></path>
                </g>
              </svg>
            </span>
            <span>
              <strong>
                {"العربية"}
              </strong>
              <small>
                {"المتابعة باللغة العربية"}
              </small>
            </span>
          </button>
        </div>
      </div>
    </div>
    </>
  );
}
